import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {StripeService} from 'ngx-stripe';
import {PaymentIntent} from '@stripe/stripe-js';
import {first, switchMap} from 'rxjs/operators';
import { formatDate, NgClass, NgIf } from '@angular/common';
import {HubspotService} from '../../../../../services/hubspot.service';
import {UserService} from '../../../../../services/user-services/user.service';
import {Observable} from 'rxjs';
import {AlertService} from '../../../../../services/alert.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GlobalConstantsComponent} from '../../../../../shared/global-constants/global-constants.component';
import {ProcessService} from '../../../../../services/user-services/process.service';
import {GlobalPaymentFormComponent} from '../../../../../shared/components/forms/global-payment-form/global-payment-form.component';
import {ProcessSharedService} from '../../../../../services/process-shared.service';
import {AuthenticationService} from 'src/app/services/authentication.service';
//import {MetaService} from 'src/app/services/meta.service';
import {Router} from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NeedHelpComponent } from '../../../../../shared/components/ux/need-help/need-help.component';
import { CheckFormErrorDirective } from '../../../../../directives/checkFormError.directive';
import { IconComponent } from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import { CodePromoInputComponent } from '../../../../../shared/components/ux/inputs/code-promo-input/code-promo-input.component';
import {LocalSettingsService} from "../../../../../services/local-settings.service";
import {HelperService} from "../../../../../services/helper.service";

@Component({
    selector: 'app-component-paiement',
    templateUrl: './component-paiement.component.html',
    styleUrls: ['./component-paiement.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        GlobalPaymentFormComponent,
        CodePromoInputComponent,
        NgIf,
        IconComponent,
        CheckFormErrorDirective,
        NeedHelpComponent,
        TranslateModule,
    ],
})
export class ComponentPaiementComponent implements OnInit {

  @Input() public price:number ;
  @Input() public booking: any;
  @Input() public room :any;
  @Input() public promoCode :any;

  public stripeError:any = null;
  public stripeTest: UntypedFormGroup;

  process;
  public isPaymentFormSubmitted = false;
  private apiUrl = GlobalConstantsComponent.apiURL;
  public isMobile = false;
  public user: any;
  public isLoading = false;
  userInformations;
  public displayBtn = true;
  promoCodeAmount= null;
  @ViewChild('globalPaymentFormComponent') private globalPaymentFormComponent: GlobalPaymentFormComponent;
  currentLanguage: string;

  constructor(
    private fb: UntypedFormBuilder,
    private hubspotService: HubspotService,
    private userService: UserService,
    private stripeService: StripeService,
    private alertService: AlertService,
    private http: HttpClient,
    private processService: ProcessService,
    private sharedProcessService: ProcessSharedService,
    private authenticationService: AuthenticationService,
    //private metaService : MetaService,
    private router : Router,
    private helperService: HelperService,
    private localSettingsService: LocalSettingsService

  ) { }

  ngOnInit() {

    this.localSettingsService.language$.subscribe(
      (language: string) => {
          this.currentLanguage = language;
      }
  );
    this.process = this.processService.getProcess('ACCOMMODATION');
    this.isMobile = this.userService.isMobileUser;
    this.user = this.userInformations = this.userService.getInfos();
    this.stripeTest = this.fb.group({
      name: [this.room.name, [Validators.required]],
      amount: [this.price, [Validators.required, Validators.pattern(/\d+/)]],
    });

    this.userService.getCityById(this.room.property_address.city_group).subscribe((data: any) => {
      let hubspotDatas = {
        budget: this.room.price,
        city: data.name,
        property_fees: this.room.property_price.reservation_fees,
        property_id: this.room.id,
        property_name: this.room.name,
        campagne: '',
        source: '',
        medium: ''
      };

      hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
      this.userService.setHubspotDeal(3321704, 11339148, hubspotDatas).subscribe();
    });
  }



  public pay(data) {
    this.isPaymentFormSubmitted = true;
    if (this.stripeTest.valid && data.valid) {
      this.isLoading = true;
      const keys = ['waiting_room', 'waiting_monthRent', 'waiting_start_date', 'waiting_end_date'];
      if(!this.promoCode){
        this.promoCode = this.userService.getFromLocal('promoCode');
      }
      if(!this.promoCodeAmount){
        this.promoCodeAmount = this.userService.getFromLocal('promoCodeAmount');
      }
      this.userService.deleteInformationsKey(keys).pipe(first()).subscribe();

      this.createPaymentIntent(this.price, this.booking.propId, this.room.name, this.user.email, 'housing',this.promoCode,this.promoCodeAmount)
        .pipe(
          switchMap((pi: any) =>
            this.stripeService.confirmCardPayment(pi.intent.client_secret, {
              payment_method: {
                card: data.card.element,
                billing_details: {
                  name: this.stripeTest.get('name').value,
                },
              },
            })
          )
        )
        .subscribe((result) => {
          if (result.error) {
            this.isLoading = false;
            // Show error to your customer (e.g., insufficient funds)
            const date = new Date();
            this.hubspotService.updateHubspot({
              date_page_paiement: Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
              failed_payment_api: result.error.message,
              methode_de_paiement: 'Stripe'
            }).subscribe();
            this.stripeError = {code: result.error.code, message: result.error.message};
            this.globalPaymentFormComponent.stripeError = this.stripeError;
            this.alertService.openSnackBar(result.error.message, 'snack-error');
            let hubspotDatas = {
              campagne: '',
              source: '',
              medium: ''
            };
            hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
            this.userService.setHubspotDeal(3321704,17760778, hubspotDatas).subscribe();
          } else if (result.paymentIntent.status === 'succeeded' || result.paymentIntent.status === 'requires_capture') {
              (async () => {
                const endDate = new Date(this.booking.endDate);
                const startDate = new Date(this.booking.startDate);
                this.booking.endDate = formatDate(this.booking.endDate, 'yyyy-MM-dd', 'en-US');
                this.booking.hubspotEndDate = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
                this.booking.startDate = formatDate(this.booking.startDate, 'yyyy-MM-dd', 'en-US');
                this.booking.hubspotStartDate = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

                this.hubspotService.updateHubspot({
                  stay_duration: this.monthDiff(startDate, endDate)
                }).subscribe();
                if (this.process) {
                  this.sharedProcessService.updateProcessState('PAYED', this.process).subscribe();
                }
                const pricepromo = this.booking.reservation_fees - this.price;
                //this.metaService.sendBuy(this.router.url, this.price, this.user ? this.user.id : 0).subscribe();

                this.userService.getCityById(this.room.property_address.city_group).subscribe((data: any) => {
                  let hubDatas = {
                    promo_code: this.promoCode,
                    promo_code_amount: pricepromo > 0 ? pricepromo : null,
                    amount: this.price.toFixed(2),
                    city: data.name,
                    property_link: this.room.link,
                    campagne: '',
                    source: '',
                    medium: ''
                  };

                  hubDatas = this.helperService.setUtmToHubspot(hubDatas);
                  this.userService.setHubspotDeal(3321704, 11339149, hubDatas).subscribe();
                });

                this.processService.saveBooking({
                  property: this.room,
                  booking: this.booking,
                  amount: this.price.toFixed(2),
                  promo_code: this.promoCode,
                  payment: result.paymentIntent,
                }).subscribe(() => {
                  this.booking.careStatus = 'pending';
                  this.processService.navigateWithDatas('Ok', 'snack-success', this.currentLanguage+'/accommodation/pending');
                  });
              })();
            }
        });
    }
  }

  private createPaymentIntent(amount: number, propertyId: number, propertyName: string, userMail: string, service: string, promoCode, promoCodeAmount): Observable<PaymentIntent> {
    const httpOptions: object = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.authenticationService.currentUserValue.token}`
      }),
      reportProgress: true,
    };

    /*const req = new HttpRequest('POST', `${this.apiUrl}create-payment-intent`,
    {amount, propertyId, propertyName, userMail, service,promoCode, promoCodeAmount},
    httpOptions);
    let exec = this.http.request(req);
    return exec;*/
    return this.http.post<PaymentIntent>(
      `${this.apiUrl}create-payment-intent`,
      {amount, propertyId, propertyName, userMail, service, promoCode, promoCodeAmount}, httpOptions
    );
  }

  public displayButton(e) {
    this.displayBtn = e;
  }

  public validate() {
    this.globalPaymentFormComponent.pay();
  }

  applyPromoCode(price) {
    this.price = price;
  }

  getPromoCodeInfos(promoCode) {
    this.promoCode = promoCode;
  }

  public monthDiff(startDate, endDate) {
    var months;
    months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += endDate.getMonth();
    return months <= 0 ? 0 : months;
  }


}
